import styled from 'styled-components'
import { Card } from 'components'

export const AddressCard = styled(Card)`
  ${({ theme: { colors } }) => `
  padding: 0.75rem 1rem;
  margin-bottom: 0.75rem;
  border: 1px solid ${colors('foreground', 0.1)};
  `}
`

export const AddressName = styled.div`
  font-weight: 600;
  margin-bottom: 0.25rem;
`

export const AddressText = styled.div`
  ${({ theme: { colors } }) => `
  color: ${colors('foreground', 0.7)};
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  `}
`

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
`

export const Tag = styled.span`
  ${({ theme: { colors } }) => `
  font-size: 0.7rem;
  padding: 0.15rem 0.5rem;
  border-radius: 1rem;
  background: ${colors('chrome')};
  color: ${colors('foreground', 0.6)};
  text-transform: capitalize;
  `}
`
